<div class="text-logo-wrap">
    <div class="text-logo">
        <img *imageWithEnvironmentPrefix="'/assets/images/logos/privalgo-text-logo-20pxh.png'" class="text-logo-img" alt="{{brandName}} Logo">
    </div>
</div>

<div class="icon-logo">
    <img class="icon-logo-img" *imageWithBrandPrefix="'/assets/images/logos/privalgo-icon-logo-84px.png'" alt="{{brandName}} Logo">
</div>

<router-outlet></router-outlet>